

export default () => {
    $(document).on('change','.fileinput',function () {
        var filename = $('.fileinput').val().split('\\').pop();
        $(this).closest('.file-upload').find('.text-show').html(filename);
    });
}
  
